import getEnv from '../utils/getEnv';
import { Experiment } from '@amplitude/experiment-js-client';

const ENV_NAME = getEnv();

const amplitudeSdkKeys: { [Key in ReturnType<typeof getEnv>]: string } = {
  production: 'client-OtEcDpyNiWopL470six2zJydPkuRSDOq' as const,
  stage2: 'client-6YzumEldVSE8ZbUie5aR6DkcKxU65DVG' as const,
  development: 'client-MVz3RaQM0wmtr9F0vOUWXnczMkkL81O4' as const
} as const;

// Initialize Amplitude Experiment SDK
export const amplitudeExperiment = Experiment.initializeWithAmplitudeAnalytics(
  amplitudeSdkKeys[ENV_NAME],
  {
    automaticExposureTracking: true
  }
);
